/**
 * Gestione Wishlist tramite Cookie
 */
const Wishlist = {
  cookieName: 'shopify_wishlist',

  // Legge i prodotti salvati
  get: function() {
    const cookie = document.cookie.split('; ').find(row => row.startsWith(this.cookieName + '='));
    return cookie ? JSON.parse(decodeURIComponent(cookie.split('=')[1])) : [];
  },

  // Aggiunge o rimuove un prodotto usando l'handle (URL slug)
  toggle: function(handle) {
  let list = this.get();
  
  // Rimuoviamo TUTTE le istanze dell'handle se già presenti (pulizia preventiva)
  const exists = list.includes(handle);
  
  if (exists) {
    list = list.filter(item => item !== handle); // Rimuove se presente
  } else {
    list.push(handle); // Aggiunge se assente
  }

  // Rimuoviamo eventuali altri duplicati "sporchi" rimasti nel cookie
  list = [...new Set(list)];

  // Salva il cookie per 30 giorni
  document.cookie = `${this.cookieName}=${encodeURIComponent(JSON.stringify(list))};path=/;max-age=2592000`;
  
  document.dispatchEvent(new CustomEvent('wishlist:updated'));
}
};